module.exports = " <div class=vc-action-sheet v-show=show transition=actionsheet> <div class=vc-action-sheet-group> <a href=javascript:; @click=actionClick(action) v-el:button :class=\"['color-' + action.color, action.isLabel ? 'vc-action-sheet-label' : 'vc-action-sheet-button']\" v-for=\"action in actions\"> {{action.name}} <ripple :trigger=$els.button></ripple> </a> </div> <div class=vc-action-sheet-group v-if=showCancel> <a class=vc-action-sheet-button href=javascript:; @click=cancel v-el:cancel> {{cancelText}} <ripple :trigger=$els.cancel></ripple> </a> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/actionSheet/actionSheet.vue
 ** module id = 413
 ** module chunks = 1
 **/